<template>
  <div
    class="accordion__item accordion-services"
    :class="{'accordion__item_active': showDeliveryServices}"
  >
    <p
      class="accordion__title"
      @click="showDeliveryServices = !showDeliveryServices"
    >
      <span class="calculator-field__label">{{ $t('calc.services') }}</span>
      <svg
        class="ms-auto"
        width="24px"
        height="24px"
      >
        <use xlink:href="#arrow-down" />
      </svg>
    </p>
    <div class="accordion__inner">
      <ul
        class="accordion__list"
      >
        <li
          v-for="(service, i) in deliveryServicesList"
          :key="i"
          class="accordion__list-item"
        >
          <svg
            width="24"
            height="24"
          >
            <use xlink:href="#ok" />
          </svg>
          {{ service.name.replace(new RegExp('\\(?ПиП\\)?', 'ig'), '') }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalculatorServicesOptions',
  props: {
    deliveryServicesList: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    showDeliveryServices: false,
  }),
};
</script>
